import { Tabs, Tab } from '@mui/material';

const ShipmentErrorBox = ({ isError, isRejected, showErrorModal }) => {
  if (isError || isRejected)
    return (
      <Tabs value={0} className="shipment-error-box" orientation="vertical">
        <div className="shipment-error-box-header">Shipment Action Required</div>
        {isError && (
          <Tab className="shipment-error-box-content" label="View errors on this shipment" onClick={showErrorModal} />
        )}
        {isRejected && (
          <Tab className="shipment-error-box-content" label="View rejected on this shipment" onClick={showErrorModal} />
        )}
      </Tabs>
    );
  return null;
};

export default ShipmentErrorBox;
